export default function hyphenate(string) {
  let stringLowercase = string.toLowerCase()
  let stringHyphenated = stringLowercase.replace(' ', '-')

  return stringHyphenated
}
